import { StoreType } from '@tock/shared/utils/connect';

export const mobileModeEnabledSelector = (store: StoreType) => store.persistedUi.mobileModeEnabled;
